module.exports = __webpack_public_path__ + "img/hand_side3_48.4b41e067.svg";